// extracted by mini-css-extract-plugin
export var fadeInAnimation = "TileIcons-module--fadeInAnimation--f9399";
export var scrollWrapper = "TileIcons-module--scrollWrapper--acd36";
export var wrapper = "TileIcons-module--wrapper--e587d";